module.exports = __webpack_public_path__ + "static/media/checkbox.1a632ea9.jpeg";